module.exports = __webpack_public_path__ + "assets/img/37_382_big.9660a182.jpg";